import React from 'react';
import {
  Card,
  CardBody,
  CardHeader,
} from '@grnhse/seedling/lib/azalea/components/card';
import { ErrorIcon } from '@grnhse/seedling/lib/azalea/icons';
import t from 'shared/utils/translation';
import styled from 'styled-components';
import rollbar from 'shared/utils/rollbar_logger';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  getComponentName() {
    const existComponent =
      typeof this.props.children !== 'undefined' &&
      typeof this.props.children.type !== 'undefined';
    const name = existComponent
      ? this.props.children.type.name
      : 'Unknown component';
    return name;
  }

  logError(error, errorInfo) {
    const cardName = this.getComponentName();
    const data = { error, information: errorInfo };
    const errorMessage = `On ${cardName}: ${error.message}`;
    rollbar.error(errorMessage, data);
  }

  componentDidCatch(error, errorInfo) {
    this.logError(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      const message = t('gdpr.gdpr_boundary_error');
      const headerLabel = this.props.label
        ? this.props.label
        : t('gdpr.gdpr_boundary_error');
      return (
        <React.Fragment>
          <CardHeader label={headerLabel} labelSize="large" />
          <Card useLegacyPadding>
            <CardBody>
              <WithMargin>
                <ErrorIcon width={'20px'} heigth={'20px'} />
              </WithMargin>
              <div>{message}</div>
            </CardBody>
          </Card>
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}

const WithMargin = styled.div`
  margin-right: 10px;
  float: left;
`;
